import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {Subscription} from "rxjs";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {StringUtils} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/stringutils";
import {ExchangePriceWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";


@Component({
    selector: 'exchange-price',
    templateUrl: './exchangeprice.component.html',
    styleUrls: ['./exchangeprice.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExchangePriceComponent implements OnInit, OnDestroy {

  protected subscriptions: Subscription[] = new Array<Subscription>();
  public currentCryptoExchangeRate: number;
  public initialCryptoExchangeRateFormatted: string;
  public countUpOptions = {
    decimalPlaces: 12,
    formattingFn: this.formatCurrency.bind(this)
  }

  @Input() public animatePriceChange = true;
  @Input() public roundAmounts = false;
  @Input() public useCompactNotation = false;

  _baseCurrency: string;
  get baseCurrency(): string {
    return this._baseCurrency;
  }
  @Input() set baseCurrency(value: string) {
    this._baseCurrency = value;
    this.updateCryptoInformation();
  }

  _quoteCurrency: string;
  get quoteCurrency(): string {
    return this._quoteCurrency;
  }
  @Input() set quoteCurrency(value: string) {
    this._quoteCurrency = value;
    this.updateCryptoInformation();
  }
  _exchangePrice: ExchangePriceWithRelations
  get exchangePrice(): ExchangePriceWithRelations {
    return this._exchangePrice;
  }
  @Input() set exchangePrice(value: ExchangePriceWithRelations) {
    this._exchangePrice = value;
    this.updateCryptoInformation();
  }

  public currentCryptoExchangeRateFormatted;

  public constructor(protected exchangeService: ExchangeService,
                     public purchaseFlowHelperService: PurchaseFlowHelperService,
                     protected stringUtils: StringUtils) {

  }

  public ngOnInit() {

    if(this.baseCurrency != null && this.quoteCurrency != null) {
      let exchangePrice = this.exchangeService.getExchangePrice(this.baseCurrency, this.quoteCurrency);
      if (exchangePrice != null) {
        this.currentCryptoExchangeRate = exchangePrice.price;
        this.countUpOptions['startVal'] = this.currentCryptoExchangeRate;
        this.initialCryptoExchangeRateFormatted = this.formatCurrency(this.currentCryptoExchangeRate);
        this.currentCryptoExchangeRateFormatted = this.initialCryptoExchangeRateFormatted;
      }
    }

    if(this._exchangePrice == null) {
      this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(exchangeRates => {
        this.updateCryptoInformation();
      }));
    }

  }

  public ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected formatCurrency(value: number): string {
    if(this.roundAmounts && value >= 1000) {
      return this.stringUtils.formatCurrencyWithoutDecimals(value, this.useCompactNotation);
    }
    else {
      return this.stringUtils.formatCurrency(value, true, this.useCompactNotation);
    }
  }

  protected updateCryptoInformation() {
    if(this.baseCurrency != null && this.quoteCurrency != null) {
      this.currentCryptoExchangeRate = this.exchangeService.calculateExchange(this.baseCurrency, 1, this.quoteCurrency);
    }
    else if(this._exchangePrice != null) {
      this.currentCryptoExchangeRate = this._exchangePrice.price;
    }
    this.currentCryptoExchangeRateFormatted = this.formatCurrency(this.currentCryptoExchangeRate);
  }

}
